export default {"src":"/_next/static/media/CreateiQ.46582c53.svg","height":40,"width":222,"blurWidth":0,"blurHeight":0};